import React, { useEffect, useState } from 'react';
import './AccountStatusBanner.css';

const API_URL = process.env.REACT_APP_API_URL || 'https://api.alooma.mg';

// Shows Creators/Brands whether their account is still waiting for Alooma
// approval (or was denied). Renders nothing once approved.
function AccountStatusBanner({ profileLink }) {
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) return;
    fetch(`${API_URL}/api/auth/me`, { headers: { Authorization: `Bearer ${token}` } })
      .then(res => (res.ok ? res.json() : null))
      .then(data => data?.user && setStatus(data.user))
      .catch(() => {});
  }, []);

  if (!status || !status.approvalStatus || status.approvalStatus === 'approved') return null;

  const denied = status.approvalStatus === 'denied';
  return (
    <div className={`account-status-banner ${denied ? 'denied' : 'pending'}`} role="status">
      <strong>{denied ? 'Account not approved' : 'Pending approval'}</strong>
      <p>
        {denied
          ? 'The Alooma team did not approve this account. Check Messages for details or contact the Alooma team.'
          : 'Thanks for joining! The Alooma team reviews every new account. You can finish your profile now; posting campaigns, bidding and browsing creators unlock once you are approved.'}
      </p>
      {!denied && profileLink && (
        <a href={profileLink} className="account-status-link">Complete your profile →</a>
      )}
    </div>
  );
}

export default AccountStatusBanner;
